import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sen-app-offer-text',
  templateUrl: './offer-text.component.html',
  styleUrls: ['./offer-text.component.scss']
})
export class OfferTextComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
